import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Popupinterface } from "../../interface/interface";
import { RootState } from "../../reducers";
import ReportPopup from "./components/ReportPopup";
import { ReactComponent as Cancel } from "./svg/cancel.svg";
import "./css/index.css";
import { PopupChange } from "../../reducers/config";
import CouponPopup from "./components/CouponPopup";
import TeamLeaderPopup from "./components/TeamLeaderPopup";
import AddPopup from "./components/AddPopup";
import ProjectCancel from "./components/ProjectCancel";
import ProjectChoice from "./components/ProjectChoice";
import FilePopup from "./components/FilePopup";
function Popup() {
  const dispatch = useDispatch();
  const { active, type, content } = useSelector<RootState, Popupinterface>(
    (state) => state.config.popup
  );
  const __cancel = useCallback(() => {
    dispatch(PopupChange({ active: false, type: "", content: "" }));
  }, []);

  return active ? (
    <div className={`popup ${active ? "popup-on" : ""}`}>
      <div className="back" />
      <div className={`card ${type}`}>
        <Cancel className="cancel" onClick={__cancel} />
        {type === "report" ? (
          <ReportPopup data={content} dispatch={dispatch} />
        ) : type === "leader" ? (
          <TeamLeaderPopup
            __cancel={__cancel}
            content={content}
            dispatch={dispatch}
          />
        ) : type === "coupon" ? (
          <CouponPopup
            __cancel={__cancel}
            dispatch={dispatch}
            content={content}
          />
        ) : type === "project" ? (
          <ProjectChoice
            __cancel={__cancel}
            content={content}
            dispatch={dispatch}
          />
        ) : type === "newadd" ? (
          <AddPopup />
        ) : type === "project-cancel" ? (
          <ProjectCancel />
        ) : type === "cert-file" ? (
          <FilePopup __cancel={__cancel} dispatch={dispatch} data={content} />
        ) : undefined}
      </div>
    </div>
  ) : (
    <></>
  );
}

export default Popup;
